
import React from 'react';
import { getConfigurazione } from '../api'; // Assicurati di avere questa funzione per ottenere i dati
import GasForm from './layout/GasForm';

export default function Configurazione() {
    return (        
        <GasForm title={"Configurazione"}
                    getAction="/configurazione"
                    saveAction="/impostaconfigurazione"
                    showConfirmation={true}
        />      
    );
}